<template>
	<header class="topo topo--desktop" ref="$el">
		<div class="container topo__fx-1" ref="$container">
			<div class="row">
				<div class="col-lg-4">
					<slot name="redes-sociais"></slot>
				</div><!--/.col-lg-4-->

				<div class="col-lg-4 align-self-center">
					<slot name="logo"></slot>
				</div><!--/.col-lg-4-->

				<div class="col-lg-4 d-flex flex-column">
					<slot name="idiomas"></slot>
					<slot name="telefone"></slot>
				</div><!--/.col-lg-4-->
			</div><!--/.row-->
		</div><!--/.container-->

		<slot name="menu"></slot>
	</header>
</template>

